import { Box, Button, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { CustomTable } from "../../../../../../../../components"
import { useReassignUserContext } from "../../context"
import { useParams } from "react-router-dom"

export const Reassign = () => {
    const { id } = useParams()
    const { columnReassign, state, services } = useReassignUserContext()
    const { loadings, reassignRow, userToReassignId } = state
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <Box sx={styles.container}>
            <Box sx={styles.header}>
                <Typography variant="subtitle_grey" fontWeight='bold'>{t('reportFolio.reassign.title')}</Typography>

                <Button onClick={() => { services.reassignUser({ id }) }} disabled={!userToReassignId || loadings.reassignSave} variant="contained">{t('general.save')}</Button>
            </Box>

            <CustomTable
                column={columnReassign}
                row={reassignRow}
                selected={-1}
                loader={loadings.reassignTable}
            />
        </Box>
    )
}